import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION2: PdfComponent = {
  type: 'section',
  id: 's2',
  title: '2. Consideration, Commencement and Term',
  content: [
    {
      type: 'bulletList',
      id: 's2bullets',
      bulletType: 'number',
      content: [
        {
          copy: 'The parties agree to comply with the terms of this Agreement in consideration of the sum of one pound (£1), the receipt and sufficiency of which are hereby acknowledged by each party.',
        },
        {
          copy: 'This Agreement shall commence on the Commencement Date and (unless terminated earlier in accordance with this Agreement) shall continue for a period of one (1) year (the Initial Term).',
        },
        {
          copy: 'At the end of the Initial Term, this Agreement will continue for further individual periods of twelve (12) months (each an Extension Period), unless and until terminated by:',
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: "Kanda giving the Subscriber not less than thirty (30) days' notice at any time; or",
              },
              {
                copy: "the Subscriber giving Kanda not less than ninety (90) days' notice prior to the expiry of the Initial Term or thirty (30) days' notice prior to the expiry of any Extension Period, such notice to expire at the end of the Initial Term or the relevant Extension Period (as applicable).",
              },
            ],
          },
          subcopy:
            'Any such extension shall be on the terms of this Agreement in force at the effective date of the relevant Extension Period.',
        },
        {
          copy: 'Clauses 2.2 and 2.3 are subject to the early termination provisions set out in clause 14 (Termination).',
        },
        {
          copy: 'The Subscriber acknowledges and agrees that Kanda may carry out identity and credit checks on the Subscriber in order to verify the information provided to Kanda. Kanda may repeat such checks on renewal of the Agreement at the end of the Initial Term or any Extension Period. For the avoidance of doubt, Kanda may terminate this Agreement in accordance with clause 2.3 based on the results of such identity or credit checks.',
        },
      ],
      prefix: '2',
    },
  ],
};
